import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import { Badge } from "@/components/ui/badge";
import { api, formatPrice } from "@/lib/api";

const STATUS_COLORS = {
  Nuovo: "bg-slate-500 text-white",
  Pagato: "bg-emerald-600 text-white",
  "Da preparare": "bg-brand-yellow text-brand-blue",
  Spedito: "bg-blue-600 text-white",
  Completato: "bg-purple-600 text-white",
  Annullato: "bg-red-500 text-white",
};

const PAYMENT_COLORS = {
  paid: "bg-emerald-600 text-white",
  pending: "bg-slate-400 text-white",
  failed: "bg-red-500 text-white",
  expired: "bg-slate-500 text-white",
  refunded: "bg-purple-500 text-white",
};

const PAYMENT_LABELS = {
  paid: "Pagato",
  pending: "In attesa",
  failed: "Fallito",
  expired: "Scaduto",
  refunded: "Rimborsato",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    const { data } = await api.get("/admin/orders");
    setOrders(data);
  };
  useEffect(() => { load(); }, []);

  const filtered = orders.filter((o) => filter === "all" || o.status === filter);

  return (
    <AdminLayout title="Ordini" back="/admin">
      <div className="scroll-row flex gap-2 overflow-x-auto pb-3 mb-2">
        {["all", "Nuovo", "Pagato", "Da preparare", "Spedito", "Completato", "Annullato"].map((f) => (
          <button
            key={f}
            data-testid={`orders-filter-${f}`}
            onClick={() => setFilter(f)}
            className={`whitespace-nowrap px-4 h-10 rounded-full text-xs font-bold border transition ${filter === f ? "bg-brand-blue text-white border-brand-blue" : "bg-white border-border"}`}
          >
            {f === "all" ? "Tutti" : f}
          </button>
        ))}
      </div>

      <div className="space-y-3">
        {filtered.map((o) => (
          <Link
            to={`/admin/ordini/${o.id}`}
            key={o.id}
            data-testid={`order-row-${o.id}`}
            className="block bg-white border border-border rounded-2xl p-4 hover:border-brand-blue transition"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-heading font-black text-brand-blue text-sm">{o.order_number}</div>
                <div className="text-xs text-slate-500 mt-0.5">
                  {new Date(o.created_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}
                </div>
                <div className="text-sm mt-1 truncate">
                  {o.customer.first_name} {o.customer.last_name} · {o.customer.city}
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="font-heading font-black text-brand-blue">{formatPrice(o.total)}</div>
              </div>
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <Badge className={`${STATUS_COLORS[o.status] || "bg-slate-500 text-white"} text-[10px] uppercase font-bold tracking-wider`}>
                {o.status}
              </Badge>
              <Badge className={`${PAYMENT_COLORS[o.payment_status] || "bg-slate-500 text-white"} text-[10px] uppercase font-bold tracking-wider`}>
                Pagamento: {PAYMENT_LABELS[o.payment_status] || o.payment_status}
              </Badge>
              <span className="text-xs text-slate-400 ml-auto">{o.line_items.length} art.</span>
            </div>
          </Link>
        ))}
        {filtered.length === 0 && (
          <div className="text-center text-slate-500 py-12">Nessun ordine</div>
        )}
      </div>
    </AdminLayout>
  );
}
